// Production candidate. No staff session, Shopify token or customer identity is shared.
(() => {
  const script = document.currentScript;
  const origin = script?.dataset.careOrigin;
  const quizPage = () =>
    /\/tools\/perfect-product-finder\/(?:hair-quiz-xrubbqrqzb|hair-quiz-colour-match-hnxfuyxlvn)\/?$/.test(
      location.pathname,
    );
  if (
    !origin ||
    origin !== 'https://logos-hadrill-care.manuel-c47.workers.dev' ||
    quizPage() ||
    document.getElementById('hadrill-care-launcher')
  )
    return;
  const initialise = () => {
    if (quizPage() || document.getElementById('hadrill-care-launcher')) return;
    const host = document.createElement('div');
    host.id = 'hadrill-care-launcher';
    const shadow = host.attachShadow({ mode: 'open' });
    const style = document.createElement('style');
    style.textContent =
      ':host{all:initial;position:fixed;right:24px;bottom:max(24px,env(safe-area-inset-bottom));z-index:2147482000}button{display:flex;align-items:center;gap:10px;font:11px/1.6 "DM Sans",sans-serif;letter-spacing:.08em;color:#282d43;text-transform:uppercase;background:#fff;border:1px solid #282d43;border-radius:4px;min-height:44px;padding:10px 18px;cursor:pointer;box-shadow:0 3px 12px #282d4314}button svg{width:18px;height:18px;display:block;fill:none;stroke:currentColor;stroke-width:1.3;stroke-linecap:round;stroke-linejoin:round;flex-shrink:0}iframe{display:block;border:0;width:360px;height:min(520px,calc(100dvh - 48px));box-shadow:0 8px 32px #282d4314;border-radius:4px}iframe[hidden],button[hidden]{display:none}button:focus-visible{outline:2px solid #282d43;outline-offset:3px}@media(max-width:480px){:host{right:16px;bottom:max(16px,env(safe-area-inset-bottom))}iframe{width:calc(100vw - 32px);height:min(540px,calc(100dvh - 32px))}}';
    if (script.dataset.carePreview === 'true') {
      style.textContent +=
        ':host{bottom:88px}iframe{height:min(520px,calc(100dvh - 112px))}@media(max-width:420px){:host{bottom:max(88px,env(safe-area-inset-bottom))}iframe{height:min(540px,calc(100dvh - 104px))}}';
    }
    const button = document.createElement('button');
    const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    icon.setAttribute('viewBox', '0 0 24 24');
    icon.setAttribute('aria-hidden', 'true');
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M20 15a3 3 0 0 1-3 3H8l-4 3V6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3Z');
    icon.append(path);
    const label = document.createElement('span');
    label.textContent = 'Chat';
    button.append(icon, label);
    button.type = 'button';
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-label', 'Open Hadrill Hair chat');
    let frame;
    let releasePage;
    // Observe only the two storefront controls this launcher must avoid.
    const obstacleSelector = '.pdp__sticky[data-sticky], #shopify-pc__banner';
    const observedObstacles = new Set();
    let positionFrame = 0;
    const schedulePosition = () => {
      if (positionFrame) return;
      positionFrame = requestAnimationFrame(() => {
        positionFrame = 0;
        positionLauncher();
      });
    };
    const resizeObserver = new ResizeObserver(schedulePosition);
    const positionLauncher = () => {
      const obstacles = [...document.querySelectorAll(obstacleSelector)];
      for (const element of observedObstacles) {
        if (!obstacles.includes(element)) {
          resizeObserver.unobserve(element);
          observedObstacles.delete(element);
        }
      }
      for (const element of obstacles) {
        if (!observedObstacles.has(element)) {
          observedObstacles.add(element);
          resizeObserver.observe(element);
        }
      }
      host.style.removeProperty('bottom');
      if (button.hidden) return;
      const launcher = host.getBoundingClientRect();
      let bottom = parseFloat(getComputedStyle(host).bottom) || 0;
      const baseBottom = bottom;
      const visible = obstacles.filter((element) => {
        const style = getComputedStyle(element),
          rect = element.getBoundingClientRect();
        return (
          !element.hidden &&
          element.getAttribute('aria-hidden') !== 'true' &&
          style.display !== 'none' &&
          style.visibility === 'visible' &&
          Number(style.opacity) !== 0 &&
          element.getClientRects().length &&
          rect.width &&
          rect.height &&
          rect.bottom > 0 &&
          rect.top < innerHeight &&
          (!element.matches('.pdp__sticky[data-sticky]') ||
            element.classList.contains('is-visible')) &&
          rect.left < launcher.right &&
          rect.right > launcher.left
        );
      });
      // A lift above one control can meet another. Resolve both without piling
      // their heights together, including banners inserted after page load.
      for (let pass = 0; pass <= visible.length; pass++) {
        const previous = bottom;
        for (const element of visible) {
          const rect = element.getBoundingClientRect();
          const top = innerHeight - bottom - launcher.height;
          const lower = innerHeight - bottom;
          if (lower + 12 > rect.top && top - 12 < rect.bottom)
            bottom = Math.max(bottom, innerHeight - rect.top + 12);
        }
        if (bottom === previous) break;
      }
      if (bottom > baseBottom) host.style.bottom = bottom + 'px';
    };
    const lockPage = () => {
      if (releasePage) return;
      const x = window.scrollX,
        y = window.scrollY;
      const fixed = getComputedStyle(document.body).position === 'fixed';
      const sheet = document.createElement('style');
      sheet.textContent = `html{overflow:hidden!important;overscroll-behavior:none!important}body{overflow:hidden!important;overscroll-behavior:none!important;${fixed ? '' : `position:fixed!important;top:${-y}px!important;left:${-x}px!important;width:100%!important;`}}`;
      document.head.append(sheet);
      releasePage = () => {
        sheet.remove();
        if (!fixed && getComputedStyle(document.body).position !== 'fixed')
          window.scrollTo({ left: x, top: y, behavior: 'instant' });
        releasePage = undefined;
      };
    };
    const focusComposer = () => {
      if (frame && !frame.hidden)
        frame.contentWindow.postMessage({ type: 'hadrill-care-focus' }, origin);
    };
    const close = () => {
      if (frame) frame.hidden = true;
      button.hidden = false;
      button.setAttribute('aria-expanded', 'false');
      releasePage?.();
      positionLauncher();
      button.focus({ preventScroll: true });
    };
    button.onclick = () => {
      if (!frame) {
        frame = document.createElement('iframe');
        frame.src = origin + '/';
        frame.title = 'Hadrill Hair chat';
        frame.setAttribute('sandbox', 'allow-scripts allow-same-origin allow-popups');
        frame.referrerPolicy = 'strict-origin';
        frame.addEventListener('load', focusComposer);
        shadow.append(frame);
      }
      frame.hidden = false;
      button.hidden = true;
      button.setAttribute('aria-expanded', 'true');
      positionLauncher();
      lockPage();
      focusComposer();
    };
    window.addEventListener('message', (event) => {
      if (
        event.origin !== origin ||
        event.source !== frame?.contentWindow ||
        event.data?.type !== 'hadrill-care' ||
        typeof event.data.open !== 'boolean'
      )
        return;
      if (!event.data.open) close();
    });
    window.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && frame && !frame.hidden) {
        event.preventDefault();
        close();
      }
    });
    window.addEventListener('pagehide', () => releasePage?.());
    shadow.append(style, button);
    document.body.append(host);
    new MutationObserver((records) => {
      const relevant = records.some((record) => {
        if (record.type === 'childList')
          return [...record.addedNodes, ...record.removedNodes].some(
            (node) =>
              node instanceof Element &&
              (node.matches(obstacleSelector) || node.querySelector(obstacleSelector)),
          );
        return (
          record.target instanceof Element &&
          (record.target.matches(obstacleSelector) ||
            [...observedObstacles].some((element) => record.target.contains(element)))
        );
      });
      if (relevant) schedulePosition();
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'],
    });
    window.addEventListener('resize', schedulePosition, { passive: true });
    window.addEventListener('scroll', schedulePosition, { passive: true });
    document.addEventListener(
      'transitionend',
      (event) => {
        if (event.target instanceof Element && event.target.matches(obstacleSelector))
          schedulePosition();
      },
      true,
    );
    positionLauncher();
  };
  window.setTimeout(initialise, Math.max(0, 30000 - performance.now()));
})();
